import {createContext} from 'react';

export const ExtraTypesListContext = createContext({});
